const SAVE_AFDELINGTEELT_FILTER = 'SAVE_AFDELINGTEELT_FILTER';
const SET_AFDELING_AFDELINGTEELT_FILTER = 'SET_AFDELING_AFDELINGTEELT_FILTER';
const RESET_AFDELINGTEELT_FILTER = 'RESET_AFDELINGTEELT_FILTER';

const initialState = () => ({
    afdelingteeltFilter: {
        bedrijf: 0,
        afdeling: 0,
        historiek: false,
    },
});

const module = {
    state: initialState(),
    mutations: {
        [SET_AFDELING_AFDELINGTEELT_FILTER] (state, payload) {
            state.afdelingteeltFilter.bedrijf = payload.bedrijfid;
            state.afdelingteeltFilter.afdeling = payload.afdelingid;
        },
        [SAVE_AFDELINGTEELT_FILTER] (state, payload) {
            state.afdelingteeltFilter = payload;
        },
        [RESET_AFDELINGTEELT_FILTER] (s) {
            const initial = initialState();
            Object.keys(initial).forEach((key) => { s[key] = initial[key]; });
        },
    },
    actions: {
        setAfdelingAfdelingteeltFilter ({ commit }, payload) {
            commit(SET_AFDELING_AFDELINGTEELT_FILTER, payload);
        },
        saveAfdelingteeltFilter ({ commit }, payload) {
            commit(SAVE_AFDELINGTEELT_FILTER, payload);
        },
        resetAfdelingteeltFilter ({ commit }, payload) {
            commit(RESET_AFDELINGTEELT_FILTER, payload);
        },
    },
    getters: {
        afdelingteeltFilter: state => state.afdelingteeltFilter,
    },
};

export default module;



// WEBPACK FOOTER //
// ./src/store/modules/afdelingteelt.js